import { addRouteMiddleware, defineNuxtPlugin, useCookie, useState, useRuntimeConfig } from '#app'
import { ofetch, FetchError } from 'ofetch'
import * as csrf from '~/functions/csrf.js'
import User from '~/models/user.js'
import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin(async (nuxtApp) => {
	const config = {
		baseUrl: useRuntimeConfig().public.apiURL,
		// baseUrl: 'http://localhost:8000',
		token: true,
		csrf: {
			url: '/sanctum/csrf-cookie',
			headerKey: 'X-XSRF-TOKEN',
			cookieKey: 'XSRF-TOKEN',
			tokenCookieKey: 'nuxt-sanctum-auth-token',
		},
		login: {
			url: '/token',
			redirect: '/',
			tokenKey: 'token',
			tokenCookieOptions: {},
		},
		logout: {
			url: '/logout',
			redirect: '/',
		},
		user: {
			url: '/user',
		},
	}

	// let routesToLoad = '~/routes/customer.js';

	// if (useRuntimeConfig().public.adminBuild) {
	// 	routesToLoad = '~/routes/admin.js';
	// }

	// let routes = await import(routesToLoad)

	// for (let i in routes.default) {
	// 	router.addRoute(routes.default[i])
	// }


	let pluginUser
	let routesHaveBeenLoaded = true
	let router = useRouter()

	const auth = useState('auth', () => ({
		user: null,
		token: null,
		isLoggedIn: false,
		expired: false,
		viewAsOriginalRole: null
	}))

	async function _load() {
		console.log('auth load')
		try {
			pluginUser = await _getUser()
			// console.log('auth load got plugin user')
		} catch (error) {
			// console.log('route _load error')
			console.error(error)
		}

		if (pluginUser) {
			// let routes = await import('~/routes/admin.js')

			// if (pluginUser.role == 'admin') {
			// 	routes = await import('~/routes/admin.js')
			// } else {
			// 	routes = await import('~/routes/customer.js')
			// }

			// for (let i in routes.default) {
			// 	// console.log('adding route', routes.default[i].name)
			// 	router.addRoute(routes.default[i])
			// }

			// routesHaveBeenLoaded = true

			nuxtApp.$tick.start(pluginUser.db_time)

			nuxtApp.$echo.channel(`user.${pluginUser.id}`)
				.notification((notification) => _handleNotification(notification))
				.listen('.InboxUpdated', (e) => {
					console.log('InboxUpdated')
					let lookFor = ['/inbox', '/notifications', '/leads', '/prospect', '/call'];

					nuxtApp.$authSanctum.refreshNotificationCounts()

					for (let i in lookFor) {
						if (nuxtApp.$router.currentRoute.value.path.indexOf(lookFor[i]) != -1) {
							nuxtApp.$event.$emit('modal-form-completed');
							// getUser(true);
							break;
						}
					}
				})

			nuxtApp.$echo.channel(`unit.${pluginUser.unit_id}`)
				.notification((notification) => _handleNotification(notification))
				.listen('.InboxUpdated', (e) => {
					console.log('InboxUpdated')
					// console.log(['/inbox', '/notifications', '/leads', '/prospect', '/call'].indexOf(nuxtApp.$router.currentRoute.value.path) != -1)
					// console.log(nuxtApp.$router.currentRoute.value.path)
					let lookFor = ['/inbox', '/notifications', '/leads', '/prospect', '/call'];

					nuxtApp.$authSanctum.refreshNotificationCounts()

					for (let i in lookFor) {
						if (nuxtApp.$router.currentRoute.value.path.indexOf(lookFor[i]) != -1) {
							nuxtApp.$event.$emit('modal-form-completed');
							// nuxtApp.$authSanctum.refreshNotificationCounts()
							// getUser(true);
							break;
						}
					}
				})
		}
	}

	await _load()

	function _authSet(key, value) {
		auth.value[key] = value

		if (key != 'user') {
			localStorage.setItem(
				'auth',
				JSON.stringify({
					token: auth.value.token,
					isLoggedIn: auth.value.isLoggedIn,
					expired: auth.value.expired,
				}),
			)
		}
	}

	async function login(data, callback = null) {
		// if (config.csrf !== null) {
		// 	try {
		// 		await csrf.get(config)

		// 		const token = useCookie('XSRF-TOKEN')

		// 		// console.log(token.value)
		// 	} catch (error) {
		// 		throw error
		// 	}
		// }

		const response = await apiFetch(config.login.url, {
			method: 'POST',
			body: JSON.stringify(data),
			// headers: {
			// 	Accept: 'application/json',
			// 	[config.csrf.headerKey]: !config.token ? decodeURIComponent(useCookie(config.csrf.cookieKey).value) : null,
			// 	Authorization: config.token ? 'Bearer ' + auth.value.token : null,
			// },
		})

		if (config.token) {
			setSanctumToken(config.login.tokenKey != null ? response[config.login.tokenKey] : response)
		}

		const user = await _getUser(true)

		if (!routesHaveBeenLoaded) {
			await _load()
		}

		rememberMe(data)

		if (callback) return callback(user)

		return loginRedirect()
	}

	async function _getUser(force = false) {
		if (getSanctumToken() == false) {
			return await logout()
		}

		if (!(auth.value.isLoggedIn != true || auth.value.expired || force)) {
			return new User(auth.value.user, {
				$vue: nuxtApp,
			})
		}

		let user = await apiFetch(config.user.url)

		if (user) {
			user = new User(user, {
				$vue: nuxtApp,
			})

			Sentry.setUser({
				fullname: user.fullName(),
				email: user.email,
				id: user.id,
				// role: user.
			});

			// const nuxtAppRuntimeConfig = useRuntimeConfig()
			const nuxtConfig = useRuntimeConfig()

			if (nuxtConfig.public.tracking) {
				try {
					window.heap.identify(user.email)

					nuxtApp.$tracking.update({
						// user_id: user.id,
						name: user.fullName(),
						first_name: user.first_name,
						last_name: user.last_name,
						email: user.email,
						user_hash: user.intercom_hash,
					})
				} catch (error) {
					console.log('tracking error', error)
				}
			}

			_authSet('isLoggedIn', true)
			_authSet('expired', false)
			_authSet('user', user)

			// console.log('new user', user)

			return user
		}

		return false
	}

	async function logout(callback) {
		try {
			const response = await apiFetch(config.logout.url, {
				method: 'POST',
			})
		} catch (error) {
			console.error(error)
		}

		_clearSession()

		if (callback) return callback(response)

		return logoutRedirect()
	}

	function _clearSession() {
		localStorage.removeItem('auth')
		useCookie(config.csrf.tokenCookieKey).value = null
	}

	function apiGetFetchHeaders() {
		// console.log('csrf', useCookie('XSRF-TOKEN').value)

		const headers = {
			Accept: 'application/json',
			// 'Content-Type': 'application/json', // stop post working?
			// [config.csrf.headerKey]: useCookie('XSRF-TOKEN').value,
			Authorization: config.token ? 'Bearer ' + auth.value.token : null,
			'Access-Control-Allow-Credentials': 'True',
		}

		const visitorId = useState('visitorId').value
		if (visitorId) {
			headers['X-Request-Ref'] = visitorId
		}

		return headers
	}

	async function apiFetch(endpoint, options) {
		// so i need to store which url we are using somewhere
		let apiEndpoint = localStorage.getItem('zapo-api-dataset');
		apiEndpoint = (apiEndpoint == null || apiEndpoint == '') 
			? config.baseUrl 
			: config.baseUrl.replace('.api.', '.api-generated.') ;

		const fetch = ofetch.create({
			baseURL: apiEndpoint,
			// credentials: 'include',
			headers: apiGetFetchHeaders(),
			// mode: 'cors',
			onRequestError: (request, error) => {
				console.log('[fetch request error]', request, error)
			},
			onResponseError: (context, response) => {
				// console.log('context', context)
				// console.log('response', response)
				if (context.response.status == 401 && nuxtApp.$router.currentRoute.value.path != '/') {
					// return logout()
				}

				if (context.response.status == 422 && context.response._data?.errors?.crm) {
					nuxtApp.$event.$emit('toast-new-message', context.response._data.message)
				}
			},
		})

		return fetch(endpoint, options)

		// console.log('endpoint', endpoint)

		// try {
		//     return fetch(endpoint, options)
		// } catch (error) {
		//     console.log('APIFETCH ERROR', error)

		//     if (endpoint == config.user.url) {
		//         localStorage.removeItem('auth')

		//         return nuxtApp.$router.push('/')
		//     }
		// }
	}

	function setSanctumToken(token) {
		useCookie(config.csrf.tokenCookieKey, config.login.tokenCookieOptions).value = token

		_authSet('token', token)
	}

	function getSanctumToken() {
		if (auth.value.token != null && auth.value.token != undefined) {
			return auth.value.token
		}

		let cookie = useCookie(config.csrf.tokenCookieKey).value

		if (cookie !== null && cookie !== undefined) {
			_authSet('token', cookie)
			return auth.value.token
		}

		_authSet('expired', true)

		return false
	}

	function loginRedirect() {
		const redirect = typeof config.login.redirect == 'function' ? config.login.redirect(auth.value.user) : config.login.redirect

		if (nuxtApp.$router.currentRoute.value.path != redirect) {
			return nuxtApp.$router.push(redirect)
		}

		return false
	}

	function logoutRedirect() {
		const redirect = typeof config.logout.redirect == 'function' ? config.logout.redirect() : config.logout.redirect

		if (nuxtApp.$router.currentRoute.value.path != redirect) {
			return nuxtApp.$router.push(redirect)
		}

		return false
	}

	function isLoggedIn() {
		return auth.value.isLoggedIn
	}

	function getUser(force = false) {
		if (force || (auth.value.user == null && auth.value.expired == false)) {
			return _getUser(force)
		}

		return new User(auth.value.user, {
			$vue: nuxtApp,
		})
	}

	function viewAsRole(role = null) {
		login({
			email: role+'@zapo.com',
			password: 'VMh5AJ&00z£f',
			browser_os: 'testing',
			browser_name: 'testing'
		}, (user) => {
			this.$router.push(user.redirect())
		})

		// if (auth.value.viewAsOriginalRole == null) {
		// 	auth.value.viewAsOriginalRole = auth.value.user.roles
		// }
		
		// if (role != null) {
		// 	auth.value.user.roles = [
		// 		{ name: 'zapo.employee' },
		// 		{ name: 'zapo.' + role },
		// 	];
		// } else {
		// 	auth.value.user.roles = auth.value.viewAsOriginalRole
		// }
	}

	function rememberMe(data) {
		if (data.remember_me) {
			localStorage.setItem(
				'rememberMe',
				JSON.stringify({
					email: data.email,
					password: data.password,
				}),
			)
		} else {
			localStorage.removeItem('rememberMe')
		}
	}

	function getRememberMe() {
		return JSON.parse(localStorage.getItem('rememberMe'))
	}

	addRouteMiddleware('auth', async () => {
		try {
			let user = await _getUser()
			// console.log('auth middleware', user)

			if (user == undefined) {
				throw new Error('Session token expired')
			}
		} catch (error) {
			// console.log('middleware error', error)
			_clearSession()
			return logoutRedirect()
		}

		return true
	})

	addRouteMiddleware('guest', async () => {
		try {
			await _getUser()
		} catch (error) {
			return true
		}

		return loginRedirect()
	})

	function apiGetConfig() {
		return config
	}

	function refreshNotificationCounts() {
		nuxtApp.$axios.post('/notifications/counts').then((res) => {
			auth.value.user.notifications = res.notifications
			auth.value.user.notifications_unread = res.notifications_unread
		})
	}

	function _handleNotification(notification) {
		console.log(notification);
		nuxtApp.$event.$emit('toast-new-message', notification.title);
		refreshNotificationCounts()

		if (notification.links != undefined) {
			for (let i in notification.links) {
				if (nuxtApp.$router.currentRoute.value.path == notification.links[i]) {
					nuxtApp.$event.$emit('modal-form-completed');
					break;
				}
			}
		}

		if (['/inbox', '/notifications', '/leads'].indexOf(nuxtApp.$router.currentRoute.value.path) != -1) {
			nuxtApp.$event.$emit('modal-form-completed');
		}
	}

	return {
		provide: {
			apiFetch,
			apiGetFetchHeaders,
			apiGetConfig,
			authSanctum: {
				login,
				logout,
				isLoggedIn,
				getUser,
				getRememberMe,
				refreshNotificationCounts,
				viewAsRole
			},
			pop: (view, options) => {
				nuxtApp.$event.$emit('modal-open', {
					view: view,
					...options,
				})
			},
		},
	}
})
